export default {
  certs: (state) => state.certs,
  certsList: (state) => state.certsList,
  loading: (state) => state.loading,
  paginator: (state) => state.paginator,
  sort: (state) => state.sort,
};
